import { getEntity } from './_utils'

export const getNote = getEntity('notes')
